import React, {
	Component,
} from "react";
import {
	View,
	TextInput,
	Dimensions,
} from "react-native";
import ResponsiveStylesheet from "react-native-responsive-stylesheet";

import StyledButton from "ae-base/Base/StyledButton";
import StyledIconButton from "ae-base/Base/StyledIconButton";
import inputStyle from "./Layout/intputStyle";
import ErrorMessage from "./Layout/ErrorMessage";

import Style from "ae-style";

import { useResources, useIdPrefix } from "@aetonix/hooks";

const styles = ResponsiveStylesheet.createSized("min-direction", {
	0: {
		container: {
			flexDirection: "row",
			alignItems: "center",
			paddingRight: Style.layout.paddingMedium / 2,
			paddingVertical: Style.layout.paddingSmall / 2,
			marginHorizontal: Style.layout.marginContent / 2,
			marginVertical: Style.layout.marginContentVertical / 2,
		},
		containerWithoutMargin: {
			flexDirection: "row",
			alignItems: "center",
			paddingRight: Style.layout.paddingMedium / 2,
			paddingVertical: Style.layout.paddingSmall / 2,
			marginVertical: Style.layout.marginContentVertical / 2,
		},
		invertColors: {
			backgroundColor: Style.colors.darkBlueGreen,
			color: Style.colors.white
		},
		input: {
			flex: 1,
			marginHorizontal: Style.layout.marginContentSmall,
			fontSize: Style.text.small,
			alignSelf: "stretch",
			paddingLeft: Style.layout.paddingSmall
		},
		inputWithoutMargin: {
			flex: 1,
			fontSize: Style.text.small,
			alignSelf: "stretch",
			paddingLeft: Style.layout.paddingSmall
		},
		containerBorder: {
			borderWidth: 2,
			borderColor: Style.look.sectionOutline,
			borderRadius: 12,
			backgroundColor: Style.colors.darkBlueGreen
		}
	},
	512: {
		container: {
			paddingHorizontal: Style.layout.paddingMedium,
			paddingVertical: Style.layout.paddingSmall,
			marginHorizontal: Style.layout.marginContent,
			marginVertical: Style.layout.marginContentVertical,
		},
		containerWithoutMargin: {
			paddingVertical: Style.layout.paddingSmall,
			marginVertical: Style.layout.marginContentVertical,
		},
		input: {
			fontSize: Style.text.standard,
			paddingLeft: Style.layout.paddingSlim
		},
		inputWithoutMargin: {
			fontSize: Style.text.standard,
			paddingLeft: Style.layout.paddingSlim
		},
	}
});

class MessageBoxComp extends Component {
	constructor(props){
		super(props);
		this.state = {
			height: "auto",
			textLength: 0,
			maxText: 0,
			maxedHeight: false
		};

		this.maxHeight = Dimensions.get("window").height / 5.2;

		this.handleSizeChange = handleSizeChange.bind(this);
		this.handleOnChangeText = handleOnChangeText.bind(this);

	}

	render(){
		const props = this.props;
		const localize = props.localize;
		const dispatch = props.dispatch;
		const send = localize("searchbox.send");
		const startUpload = props.startUpload;
		const height = {
			height: this.state.height
		};

		const invertColors = props.invertColors;
		const aTouchAway = props.aTouchAway;
		const noSendButton = props.noSendButton;
		const noFileUploadButton = props.noFileUploadButton;
		const styledInput = props.noMargin ? [styles.inputWithoutMargin, height] : [styles.input, height];
		const containerStyle = props.noMargin ? [styles.containerWithoutMargin] : [styles.container];
		let placeholderTextColor = null;

		const renderSendButton = !noSendButton ? (
			<StyledButton id={props.id + "_send"} emphasized={invertColors} textStyle={ aTouchAway ? {color: "#51A0A4"} : null} aTouchAway={aTouchAway} tertiary={invertColors} clear title={send} icon="aeto-messaging" onPress={props.onSubmit} />
		) : null;

		const renderFileUploadButton = !noFileUploadButton ? (
			<StyledIconButton id={props.id + "_openFileDialog"} clear icon="aeto-add" onPress={startUpload} />
		) : null;

		if(invertColors){
			styledInput.push(styles.invertColors);
			containerStyle.push(styles.containerBorder);
			placeholderTextColor = Style.colors.white;
		} else {
			containerStyle.push(inputStyle.style);
		}

		let onContentSizeChange = !this.state.maxText || this.state.maxText >= this.state.textLength ? this.handleSizeChange : null;


		if(props.textInputStyles)
		       styledInput.push(props.textInputStyles);


		return (
			<View style={containerStyle}>
				<ErrorMessage id={props.id_prefix + props.id + "_error"} errors={props.errors} schema={props.schema} />
				{renderFileUploadButton}
				<TextInput
					id={props.id_prefix + props.id}
					style={styledInput}
					onChangeText={this.handleOnChangeText}
					defaultValue={props.defaultValue}
					placeholder={props.placeholder}
					accessibilityLabel="Message Box"
					placeholderTextColor={placeholderTextColor}
					onFocus={dispatch("keyboard:trigger:open")}
					onBlur={dispatch("keyboard:trigger:close")}
					onContentSizeChange={onContentSizeChange}
					value={props.value}
					multiline
					disableFullscreenUI
				/>
				{renderSendButton}
			</View>
		);
	}
}


function handleSizeChange(event){
	const height = event.nativeEvent.contentSize.height;
	const minSize = Style.text.hugeHeading + Style.text.tiny;
	this.setState({
		height: height <= minSize ? minSize : height,
		maxedHeight: false,
		maxText: 0
	});
}

function handleOnChangeText(text){
	const length = text.length;
	const state = {
		textLength: length
	};
	if(this.state.height >= this.maxHeight && !this.state.maxedHeight){
		state.maxText = length;
		state.maxedHeight = true;
	}

	this.setState(state);
	this.props.onChange(text);
}

export default function MessageBox(props){
	const { localize, dispatch, localizeFrom } = useResources();
	const idPrefix = useIdPrefix();
	return (
		<MessageBoxComp {...props} id_prefix={idPrefix} localize={localize} dispatch={dispatch} localizeFrom={localizeFrom} />
	);
}